import { render, staticRenderFns } from "./CoreGroupbuyingsCreateOrEditV2.vue?vue&type=template&id=20b5b43e&"
import script from "./CoreGroupbuyingsCreateOrEditV2.vue?vue&type=script&lang=js&"
export * from "./CoreGroupbuyingsCreateOrEditV2.vue?vue&type=script&lang=js&"
import style0 from "./CoreGroupbuyingsCreateOrEditV2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports